import React, { useEffect } from "react";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Image from "next/image";
import { useRouter } from "next/router";
import BoldKing from "assets/images/boldking.png";
import KickResume from "assets/images/kick-resume.png";
import MasterCard from "assets/images/mastercard.png";
import Visa from "assets/images/visa.png";
// import Selz from "assets/images/selz.png";
import { PaymentWrapper } from "../signp.styles";
import { StripeForm } from "./stripe-ui";

const stripe_pk = process.env.NEXT_PUBLIC_DEVELOPMENT_STRIPE_CLIENT_ID;

const stripePromise = loadStripe(`${stripe_pk}`);

const Step2 = () => {
   const router = useRouter();
   const query = router.query;

   useEffect(() => {
      if (query.apiKey) {
         localStorage.setItem("token", `${query.apiKey}`);
      }
   }, []);

   return (

      <div className="wrapper">
         <div className="text-block">
            <div className="base">
               <small>STEP 2 OF 4</small>
               <p>Credit Card</p>
            </div>
            <div className="info">
               <h2> Confirm your 14 days trial </h2>
               <p>
                  Your account will not be charged today. Your first charge is in 14 days. You can
                  cancel at anytime
               </p>
            </div>
         </div>

         <PaymentWrapper style={{ marginTop: "2em" }}>
            <Image src={MasterCard} alt="Stripe" />
            <Image src={Visa} alt="Stripe" />
         </PaymentWrapper>

         <Elements stripe={stripePromise}>
            <ElementsConsumer>
               {({ stripe, elements }) => <StripeForm stripe={stripe} elements={elements} />}
            </ElementsConsumer>
         </Elements>


         {/* <PaymentWrapper style={{ marginTop: "4em" }}>
            <Image src={KickResume} alt="KickResume" />
            <Image src={BoldKing} alt="BoldKing" />
            <Image src={Selz} alt="Selz" />
         </PaymentWrapper> */}

      </div>
   );
};

export { Step2 };
